import { Alert } from '@compass/components'
import { AppRoute } from 'appRoutes'
import { Zap } from 'lucide-react'
import { ampli } from 'models/ampli'

const MAX_DISPLAYED_SIGNALS = 5

export interface SmartSignalsUpsellBannerProps {
  intro: string
  disabledSignalNames: string[]
  pagePath: string
  className?: string
}

export function SmartSignalsUpsellBanner({
  intro,
  disabledSignalNames,
  pagePath,
  className,
}: SmartSignalsUpsellBannerProps) {
  if (disabledSignalNames.length === 0) {
    return null
  }

  const displayed = disabledSignalNames.slice(0, MAX_DISPLAYED_SIGNALS)
  const hasMore = disabledSignalNames.length > MAX_DISPLAYED_SIGNALS

  const formatSignalList = () => {
    if (hasMore) {
      return displayed.join(', ') + ', and more'
    }
    if (displayed.length === 1) {
      return displayed[0]
    }
    if (displayed.length === 2) {
      return `${displayed[0]} and ${displayed[1]}`
    }
    return displayed.slice(0, -1).join(', ') + ', and ' + displayed[displayed.length - 1]
  }

  const signalList = formatSignalList()

  return (
    <Alert
      variant='secondary'
      icon={<Zap />}
      className={className}
      actionProps={[
        {
          children: 'Request a trial',
          href: AppRoute.ContactSalesEnterprise,
          onPress: () => {
            ampli.appCtaClicked({ 'App Page Path': pagePath, ctaName: 'Request a trial' })
          },
        },
      ]}
    >
      {intro} {signalList}.
    </Alert>
  )
}
